import React from 'react';

import LabelValueList from 'components/list/labelValueList/LabelValueList';
import Text from 'components/typography/text/Text';

import usePoolTimezone from 'hooks/usePoolTimezone';

import { InputSignalLatestDataProps } from './InputSignalLatestData.types';

const InputSignalLatestData: React.FC<InputSignalLatestDataProps> = ({ latest_data }) => {
  const { formatDate } = usePoolTimezone();

  const timestamp = latest_data?.timestamp;
  const data = latest_data?.data;

  const dataValues = data && Object.entries(data).map(([key, value]) => {
    if (key === 'timestamp') {
      return (
        {
          label: key[0].toUpperCase() + key.slice(1),
          value: formatDate(value),
        }
      )
    } else {
      let dataValue = value;

      if (typeof value === 'object' && value !== null) {
        dataValue = Object.entries(value).map(([key, value]) => `${key}:${value}`).join(', ')
      }

      return (
        {
          label: key[0].toUpperCase() + key.slice(1).replace('_', ' '),
          value: dataValue,
        }
      )
    }
  }).sort((a, b) => {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  });


  return <fieldset>
    <legend>Latest data</legend>

    <Text><b>{formatDate(timestamp)}</b></Text>
    {data && (
      <LabelValueList
        values={dataValues}
        listId='inputSignalLatestDataList'
        loading={!data}
        loadingItemLength={2}
      />
    )}
  </fieldset>;
};

export default InputSignalLatestData;
